<p class="{{class}}" [innerHTML]="message">
</p>
